// extracted by mini-css-extract-plugin
module.exports = {"productHeader":"product-page-module--productHeader--qAZUX","featuredImage":"product-page-module--featuredImage--2qCdk"};